import { useState, useRef, useEffect } from 'react'
import { createModel } from 'hox'
import { useMap } from 'ahooks';
import { totalModel } from '../total/totalModel'
import { TablePaginationConfig } from 'antd/es/table/interface'
import { DEFAULT_FIRST_PAGE_NUM, DEFAULT_PAGE_SIZE } from '@/utils/constants'
import { settleService } from '../../settleService'
import { BillDetailResult, BillDetailContent } from '../../settleTypes'
import { transPgToPagination } from '@/model/globalModel'
import { ISearchPage } from '@/types/AppTypes'

export const detailModel = createModel(function () {

    const { billCode } = totalModel()

    //列表数据源
    const [dataSource, setDataSource] = useState<BillDetailResult[]>([])
    //查询条件
    const [searchParam, setSearchParam] = useState<any>({})
    //分页参数
    const initPgCfg: TablePaginationConfig = { pageSize: DEFAULT_PAGE_SIZE, current: DEFAULT_FIRST_PAGE_NUM }
    const [pgCfg, setPgCfg] = useState<TablePaginationConfig>(initPgCfg);
    const pgCfgRef = useRef<TablePaginationConfig>(initPgCfg);
    //表单数据
    const [formInfo, { set: setFormInfo, get: getFormInfo }] = useMap<string, any>([]);
    //弹窗可见
    const [mode, setMode] = useState<string>("add") //add、edit
    const [visible, setVisible] = useState<boolean>(false)

    const [loading, setLoading] = useState(false)

    useEffect(() => {
        pgCfgRef.current = pgCfg
    }, [pgCfg])

    //列表数据
    const loadData = async (page: ISearchPage = pgCfgRef.current, searchValue: any = searchParam) => {
        setLoading(true)
        const searchParams = {
            searchItem: {
                ...searchValue,
                "billCode": billCode,
            },
            pageSize: page?.pageSize ?? DEFAULT_PAGE_SIZE,
            pageNum: (page?.current || page?.pageNum) ?? pgCfg.current ?? DEFAULT_FIRST_PAGE_NUM,
            orders: [{ column: 'createTime', rule: 'DESC' }],
        }
        let { retData } = await settleService.detail(searchParams)
        const { list, ...pg } = retData

        const orderList = list?.map(item => {
            const content: BillDetailContent = JSON.parse(item.franchiseeBillOrder.content);
            const obj: any = {}
            content?.fields?.forEach((e) => {
                obj[e.fieldCode] = e.fieldValue
            })
            const columns = content?.fields?.map(e => {
                return {
                    title: e.fieldName,
                    width: e.fieldName.length * 16,
                    align: 'center',
                    dataIndex: e.fieldCode
                }
            });
            //维修项目、维修配件
            obj["itemsList"] = content?.itemsList;
            obj["materialList"] = content?.materialList;
            return { ...item, ...obj, "columns": columns };
        })

        setPgCfg(transPgToPagination(pg))
        setDataSource(orderList)
        setLoading(false)
    }

    //设置搜索value
    const updateSearchParam = (updateParam: any) => {
        setSearchParam({ ...searchParam, ...updateParam })
    }

    //重置搜索参数
    const resetSearchParam = () => {
        setSearchParam({})
        loadData(initPgCfg, {})
    }

    //获取一条详情数据 Api
    const getOne = async (mode: string, id: string) => {
        let { retData } = await settleService.one(id)
        const { ...formVal } = retData
        retData && setFormInfo(mode, { ...formVal });
    }

    return {
        /***field***/
        searchParam,
        dataSource,
        pgCfg,
        visible,
        mode,
        formInfo,
        loading,
        /***method***/
        setDataSource,
        resetSearchParam,
        updateSearchParam,
        loadData,
        getOne,
        setVisible,
        setMode,
        setFormInfo,
        getFormInfo,
    }
})
